import { Progress } from "antd";
import React, { useState } from "react";
import { use } from "react";
import {
    enumBonusRuleType,
    enumBonusStatus,
    isPostPartnerBonusType,
    isPrePartnerBonusType,
} from "../../actions/constantsData";
import { calculateTimeDifference, showErrorToast } from "../../actions/helper";
import {
    cancelBonus,
    CardIcons,
    checkSignUpBonus,
    getPreBonusCancellationEligibility,
} from "../../data/wallet";
import promotionErrorConfigModule from "../promotionModalConfigModule";
import { getCurrentTurnoverAndRequiredTurnover, handleCancelSignUpBonusError } from "../../actions/util";
import SignUpPostBonusCancelForm from "./BonusCancelModals/SignUpPostBonusCancelForm";
import SignUpPreBonusCancelForm from "./BonusCancelModals/SignUpPreBonusCancelForm";
import { piwikBonus } from "../../actions/piwikUtil";
import SignUpBonusConfirmModal from "./BonusCancelModals/SignUpBonusConfirmModal";
import { CountdownTimer } from "../Wallet/OWForm/OWutil";
import PromotionOneWalletModal from "../../pages/PromotionOneWalletModal";

export const HoverEllipsisDropdown = ({ cancelFlow }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            style={{ position: "relative", display: "inline-block" }}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
        >
            {/* Ellipsis */}
            <div style={{ cursor: "pointer", padding: "10px" }}>
                <span
                    style={{
                        display: "block",
                        width: "4px",
                        height: "4px",
                        borderRadius: "50%",
                        backgroundColor: "#888",
                        marginBottom: "4px",
                    }}
                ></span>
                <span
                    style={{
                        display: "block",
                        width: "4px",
                        height: "4px",
                        borderRadius: "50%",
                        backgroundColor: "#888",
                        marginBottom: "4px",
                    }}
                ></span>
                <span
                    style={{
                        display: "block",
                        width: "4px",
                        height: "4px",
                        borderRadius: "50%",
                        backgroundColor: "#888",
                    }}
                ></span>
            </div>

            {/* Dropdown Menu */}
            {isHovered && (
                <div
                    style={{
                        position: "absolute",
                        top: "30px",
                        right: "0",
                        backgroundColor: "#fff",
                        boxShadow:
                            "3px 3px 3px rgba(0, 0, 0, 0.25), 3px 3px 6px rgba(0, 0, 0, 0.35)",
                        borderRadius: "4px",
                        zIndex: 100,
                        padding: "8px",
                    }}
                    onClick={() => {
                        console.log("HoverEllipsisDropdownClicked");
                        piwikBonus.run16();
                        cancelFlow();
                    }}
                >
                    <div
                        style={{
                            padding: "8px 16px",
                            cursor: "pointer",
                            // borderBottom: "1px solid #ddd",
                        }}
                        className="hover-item"
                    >
                        Hủy
                    </div>
                </div>
            )}
        </div>
    );
};

const BottomSection = ({ type, item }) => {
    let currentTurnover, requiredTurnover, percent;

    switch (type) {
        case "progressBar":
            [currentTurnover, requiredTurnover] =
                getCurrentTurnoverAndRequiredTurnover(item);
            percent = Math.floor((100 * currentTurnover) / requiredTurnover);
            console.log("progress percent", currentTurnover, requiredTurnover)
            return (
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            marginBottom: "8px",
                            color: "#333",
                        }}
                    >
                        <div>
                            Tiến độ Doanh thu:{" "}
                            <span
                                style={{
                                    color: "#00A6FF",
                                    fontWeight: "bold",
                                }}
                            >
                                {currentTurnover}
                            </span>{" "}
                            / <span>{requiredTurnover}</span>
                        </div>
                        <div>{percent} %</div>
                    </div>
                    <Progress percent={percent} showInfo={false} />
                </div>
            );
        case "note":
            return (
                <div>
                        <div
                            style={{
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                                marginBottom: "8px",
                                color: "#333",
                            }}
                        >
                            <div>Tiến độ Doanh thu</div>
                            <div
                                style={{
                                    color: "#EB2121",
                                }}
                            >
                                Đang tìm kiếm
                            </div>
                        </div>
                    <div
                        style={{
                            backgroundColor: "#FFF5BF",
                            padding: "8px",
                            borderRadius: "4px",
                            //   border: "1px solid #FFD580",
                            color: "#83630B",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "12px",
                            fontWeight: "400",
                        }}
                    >
                        <img
                            src="/vn/img/1wallet/00/infoBrown.svg"
                            alt="info"
                            style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "8px",
                                color: "#83630B",
                            }}
                        />
                        <div>
                            Doanh thu cho khuyến mãi này không được tích lũy;
                            vui lòng liên hệ với CSKH để được hỗ trợ.
                        </div>
                    </div>
                </div>
            );
        case "noteProcessing":
            return (
                <div>
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            marginBottom: "8px",
                        }}
                    >
                        <div>Tiến độ Doanh thu</div>
                        <div
                            style={{
                                color: "#666666",
                            }}
                        >
                            Chờ Kiểm Tra
                        </div>
                    </div>
                    <div
                        style={{
                            backgroundColor: "#FFF5BF",
                            padding: "8px",
                            borderRadius: "4px",
                            //   border: "1px solid #FFD580",
                            color: "#83630B",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "12px",
                            fontWeight: "400",
                        }}
                    >
                        <img
                            src="/vn/img/1wallet/00/infoBrown.svg"
                            alt="info"
                            style={{
                                width: "16px",
                                height: "16px",
                                marginRight: "8px",
                                color: "#83630B",
                            }}
                        />
                        <div>
                            Tiền thưởng đang trong giai đoạn kiểm tra, vui lòng chờ đến khi được chấp thuận
                        </div>
                    </div>
                </div>
            );
        default:
            return (
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        width: "100%",
                        marginBottom: "8px",
                        marginTop: "10%",
                        color: "#666666",
                    }}
                >
                    <div>Tiến độ Doanh thu</div>
                    <div>Đang chờ xử lý</div>
                </div>
            );
    }
};

const checkBonusBonusType = (item) => {
    console.log("checkBonusBonusType", item);
    let bonusType;
    if (item.bonusStatusId === enumBonusStatus.RequiredCheck.ID) {
        bonusType = "note";
    } else if (item.bonusStatusId === enumBonusStatus.Processing.ID) {
        bonusType = "noteProcessing";
    } else if (item.bonusStatusId === enumBonusStatus.Pending.ID) {
        bonusType = "pending";
    } else if (
        item.bonusStatusId != enumBonusStatus.RequiredCheck.ID &&
        item.bonusStatusId != enumBonusStatus.Pending.ID
    ) {
        bonusType = "progressBar";
    }
    return bonusType;
};

const AppliedInProgressPromotionCard = (item) => {
    console.log("AppliedInProgressPromotionCardprops", item);
    const [showSignUpPostBonusCancelForm, setShowSignUpPostBonusCancelForm] = useState(false);
    const [showSignUpPreBonusCancelForm,setShowSignUpPreBonusCancelForm] = useState(false);
    const [preBonusFormProps, setPreBonusFormProps] = useState({});
    const [signUpBonusConfirmModal, setSignUpBonusConfirmModal] = useState(false);
    const [showErorModal, setShowErrorModal] = useState(false);
    const [apiError, setApiError] = useState({});
    const [modalProps, setModalProps] = useState({});
    let bonusType = checkBonusBonusType(item);
    const cancelPreBonus = (item) => {
        getPreBonusCancellationEligibility(item).then((res) => {
            console.log("cancelPreBonus240", res);
            if (
                res.isSuccess &&
                typeof res.result?.isTurnoverProgress === "boolean"
            ) {
                let caseResp =
                    getPreBonusCancellationEligibility.getCaseResult(res);

                console.log("getPreBonusCancellationEligibility298", caseResp);
                const {
                    isWin = false,
                    isLose = false,
                    isNoBet2WinLose = false,
                    pullbackAmount = 0,
                    bonusGivenAmount = 0,
                    winningAmount = 0,
                } = caseResp;
                let formProps = {
                    item,
                    pullbackAmount,
                    isWin,
                    isLose,
                    isNoBet2WinLose,
                    bonusGivenAmount,
                    winningAmount,
                };
                setPreBonusFormProps(formProps);
                setShowSignUpPreBonusCancelForm(true);
            } else {
                const { errorCode, message: apiMessage, data: unfinishInfo } = res?.result || {};
                Pushgtagdata(
                    "Bonus",
                    "Cancel Bonus",
                    "Bonus_C_Cancel",
                    false,
                    [
                        {
                            customVariableKey: "Bonus_C_Cancel_ErrorMsg",
                            customVariableValue: apiMessage,
                        },
                    ]
                );
                console.log("cancelPreBonusError280", res);
                let err = handleCancelSignUpBonusError(res)
                    if (err?.showModal) {
                        setShowErrorModal(true);
                        setApiError(err.config);
                        return;
                    }
                    showErrorToast();
            }
        });
    };

    const cancelPostBonus = (item) => {
        getPreBonusCancellationEligibility(item).then((res) => {
            if (
                res.isSuccess &&
                typeof res.result?.isTurnoverProgress === "boolean"
            ) {
                setShowSignUpPostBonusCancelForm(true);
            } else {
                console.log("cancelPostBonusError352", res);
                const { errorCode, message: apiMessage, data: unfinishInfo } = res?.result || {};    
                Pushgtagdata(
                    "Bonus",
                    "Cancel Bonus",
                    "Bonus_C_Cancel",
                    false,
                    [
                        {
                            customVariableKey: "Bonus_C_Cancel_ErrorMsg",
                            customVariableValue: apiMessage,
                        },
                    ]
                );
                let err = handleCancelSignUpBonusError(res)
                if (err?.showModal) {
                    setShowErrorModal(true);
                    setApiError(err.config);
                    return;
                }
                showErrorToast("Hủy bỏ không thành công"); 
            }
        });
    };

    const proceedToCacelSignUpBonus = (item) => {
        if (isPrePartnerBonusType(item)) {
            console.log("cancelPreBonusFlow320Pre", item);
            cancelPreBonus(item);
        } else {
            console.log("cancelPostBonusFlow", item);
            cancelPostBonus(item);
        }
    }

    const cancelFlow = async () => {
      console.log("cancelFlowStart", item);
        let res = await checkSignUpBonus(item?.productGroup);
        console.log("checkSignUpBonus", res?.isSuccess, res?.result);
        console.log("checkSignUpBonusresult", res);
        if (checkSignUpBonus.isSignupBonus(res)) {
          console.log("proceedToCacelSignUpBonus", item);
          setSignUpBonusConfirmModal(true);
        } else {
            console.log("cancelReloadBonusFlow", item);
            proceedToCacelSignUpBonus(item);
        }
    };

    const callbackAfterCancel = () => {
        item?.updateAppliedHistory();
    }

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                border: "1px solid #ddd",
                borderRadius: "8px",
                backgroundColor: "#fff",
                padding: "16px",
                boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.1)",
            }}
        >
            <div
                style={{
                    display: "flex",
                    alignItems: "center",
                    marginBottom: "16px",
                }}
            >
                {/* <img src={icon} alt="icon" style={{ width: "40px", height: "40px", marginRight: "16px" }} /> */}
                <div
                    style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        alignItems: "center",
                        paddingRight: "5px",
                    }}
                >
                    <h4 style={{ margin: 0 }}>
                        {item?.bonusName || "---"}
                    </h4>
                    {/* <span style={{ color: "#888" }}>{status}</span> */}
                    <div
                        style={{
                            cursor: "pointer",
                        }}
                    >
                        <CardIcons
                            productGroups={{
                                productGroup: item?.productGroup,
                            }}
                        />
                    </div>
                </div>
                <HoverEllipsisDropdown cancelFlow={cancelFlow} />
            </div>

            <div
                style={{
                    marginBottom: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <p style={{ margin: "0 0 4px" }}>
                    {item?.bonusRuleType === enumBonusRuleType.PRE
                        ? "Thưởng trả trước"
                        : "Thưởng có sẵn"}
                </p>
                <h3 style={{ margin: 0, color: "#000" }}>
                    {item?.bonusAmount} đ
                </h3>
            </div>

            <div
                style={{
                    marginBottom: "16px",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <p style={{ margin: "0 0 4px" }}>Đếm ngược đến hết giờ</p>
                <p style={{ margin: 0, color: "#888" }}>
                    <CountdownTimer deadline={item?.expiredDate} />
                </p>
            </div>

            <div>
                <BottomSection type={bonusType} item={item} />
            </div>
            <SignUpPostBonusCancelForm item={item}
            callbackAfterCancel={callbackAfterCancel}
            handleClose={() =>{setShowSignUpPostBonusCancelForm(false)}} 
            visible={showSignUpPostBonusCancelForm}
            />
            <SignUpPreBonusCancelForm item={item}
            callbackAfterCancel={callbackAfterCancel}
            handleClose={() =>{setShowSignUpPreBonusCancelForm(false)}}
            visible={showSignUpPreBonusCancelForm}
            PreBonusFormProps={preBonusFormProps}
            />
            <SignUpBonusConfirmModal visible={signUpBonusConfirmModal}
            handleClose={() => {setSignUpBonusConfirmModal(false)}}
            callbacks={{
                handleClose: () => {setSignUpBonusConfirmModal(false)},
                handleConfirm: () => {proceedToCacelSignUpBonus(item)}
            }}
            />
            <PromotionOneWalletModal
                isVisible={showErorModal}
                config={apiError}
                onClose={() => {
                    setShowErrorModal(false);
                    setApiError({});
                    setModalProps({});
                }}
                props={modalProps}
            />
        </div>
    );
};

export default AppliedInProgressPromotionCard;
